import React from 'react';
import {
  Card,
  CardLeft,
  IconWrapper,
  Info,
  Label,
  Value,
  Unit,
  ArrowIconWrapper,
} from './RecordCard.styled';
import {
  ArrowRightIcon,
} from '../../../../../../components/Icons';

export interface VitalCardProps {
  /** アイコン要素 */
  icon: React.ReactNode;
  /** ラベル（例: 体温、血圧） */
  label: string;
  /** 値（例: 36.5） */
  value: string | number;
  /** 単位（例: ℃、mmHg） */
  unit?: string;
  /** 補足値（例: 血圧の拍/分） */
  supplementValue?: string;
  /** 補足単位 */
  supplementUnit?: string;
  /** クリックハンドラ */
  onClick?: () => void;
  /** クリック可能か */
  clickable?: boolean;
}

/**
 * VitalCard（Molecule）
 * バイタル情報を表示するカードコンポーネント
 */
export const VitalCard: React.FC<VitalCardProps> = ({
  icon,
  label,
  value,
  unit,
  supplementValue,
  supplementUnit,
  onClick,
  clickable = true,
}) => {
  // キーボード操作対応
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (clickable && onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  // アクセシビリティ用のラベルテキスト
  const ariaLabel = `${label}: ${value}${unit || ''}${
    supplementValue ? `, ${supplementValue}${supplementUnit || ''}` : ''
  }${clickable ? '。詳細を表示' : ''}`;

  return (
    <Card
      onClick={clickable ? onClick : undefined}
      onKeyDown={handleKeyDown}
      tabIndex={clickable ? 0 : undefined}
      role={clickable ? 'button' : 'group'}
      aria-label={ariaLabel}
      $clickable={clickable}
    >
      <CardLeft>
        <IconWrapper aria-hidden="true">{icon}</IconWrapper>
        <Info>
          <Label
            $hasMinWidth={true}
          >{label}</Label>
          <Value>
            {value}
            {unit && <Unit>{unit}</Unit>}
            {supplementValue && (
              <>
                <span style={{ marginLeft: '4px' }}>{supplementValue}</span>
                {supplementUnit && <Unit>{supplementUnit}</Unit>}
              </>
            )}
          </Value>
        </Info>
      </CardLeft>
      {clickable && <ArrowIconWrapper><ArrowRightIcon /></ArrowIconWrapper>}
    </Card>
  );
};

export default VitalCard;
